<template>
    <div class="project-home flex h-[calc(100vh-64px)] justify-center overflow-y-auto  bg-grey-20 px-10">

        <div class="project-home-content flex w-[1200px] flex-col">

            <div class="flex items-center justify-between py-5">
                <span class="text-base font-semibold text-black">
                    {{ t('projects') }}
                </span>

                <button v-if="!isEmpty" class="th-btn" @click="createProject">
                    <PtIcon class="th-btn-icon text-2xl" icon="SolidAddMedium"/>
                    {{ t('createProject') }}
                </button>
            </div>

            <div v-if="getProjectListLoading" class="mt-40 flex items-center justify-center">
                <CatLoading />
            </div>

            <Empty v-else-if="isEmpty" @add-project="createProject" />

            <ProjectLayout v-else :projects="projects" @remove-project="removeProject" @pin-project="pinProject"
                           @cancel-pin-project="unpinProject" />

            <p v-if="!isEmpty" class="mt-auto pb-5 text-center text-sm text-grey-90 "> 一 {{ t('tips') }} 一 </p>
        </div>
    </div>
</template>

<script setup lang="ts">
import { PtIcon } from 'patsnap-biz';
import Empty from '@/pages/home/components/Empty.vue'
import { useProjectList } from './use-project-list';
import ProjectLayout from './components/ProjectLayout.vue'
import { CatLoading } from '@eureka/cat'
import { useI18n } from 'vue-i18n';
import '@patsnap-ui/icon/assets/solid/AddMedium.svg'

const { t } = useI18n()

const { isEmpty, getProjectListLoading, projects, createProject, removeProject, pinProject, unpinProject } = useProjectList();
</script>

<style lang="scss">
.project-home {
    @apply bg-right-bottom bg-no-repeat;
    background-image: url('@/assets/images/bg-right-bottom.svg');

    .project-home-content {
        @apply bg-no-repeat;
        background-image: url('@/assets/images/bg-left-top.svg');
        background-position: 160px 82px;
    }
}
</style>
